module.exports = __webpack_public_path__ + "img/Modernisme_Norske_lyrikere7.869ede99.jpg";